export default __webpack_public_path__ + "static/media/sequenceNotShared1.0f7531f2.png";